import React, { PropsWithChildren } from 'react';
import { CenteredContainer } from '.';

type ErrorLayoutProps = PropsWithChildren<{}>;

const ErrorLayout = ({ children }: ErrorLayoutProps) => {
    return (<CenteredContainer>
        {children}
    </CenteredContainer>);
};

export default ErrorLayout;
